module.exports = __webpack_public_path__ + "img/chatbot.d047a41d.png";